export const timesheetLocales = {
  billAmount: "Bill Amount",
  billableHours: "Billable Hours",
  billRate: "Bill Rate",
  billRatePerDay: "Bill Rate per day",
  billRatePerHour: "Bill Rate per hour",
  breakTime: "Break/Lunch Time",
  cellRendererView: "View",
  columnFieldActionRequiredBy: "Action Required By",
  columnFieldComments: "Comments",
  ColumnFieldDisputeRaisedBy: "Dispute Raised By",
  columnFieldDisputeReason: "Dispute Reason",
  date: "Date",
  dentalProfessionalName: "Dental Professional Name",
  defaultTime: "0 Hour 0 Min",
  descriptionError: "Please enter a description",
  endDate: "End Date",
  endTime: "End Time",
  headingTimesheetDetails: "Timesheet Details",
  headingTimesheetDisputeDetails: "Timesheet Dispute Details",
  hours: "Hours",
  id: "Id",
  invoiceNumber: "Invoice Number",
  jobId: "Job Id",
  jobRole: "Job Role",
  modalCancelButton: "Cancel",
  modalConfirmButton: "Confirm",
  modalDropdownFieldOffice: "Office",
  modalDropdownFieldPleaseSelect: "Please select",
  modalDropdownFieldProfessional: "Professional",
  modalTextareaTitle: "Comments",
  modalTitleActionAcquiredBy: "Action Required By",
  modalTitleHeadingSolveDispute: "Solve Dispute",
  notAvailable: "NA",
  officeName: "Office Name",
  optionSelectError: "Please select an option",
  otherExpense: "Expenses (Travel + Lodging + Other)",
  paid: "Paid",
  unPaid: "Unpaid",
  paymentStatus: "Payment Status",
  payRate: "Pay Rate",
  payRatePerDay: "Pay Rate per day",
  timesheetUpdatedSuccess: "Timesheet updated Successfully",
  payRatePerHour: "Pay Rate per hour",
  payrollJob: "Payroll Job",
  professionalId: "I.D #",
  professionalName: "Professional Name",
  professionalTimesheetList: "Professional Timesheet List",
  proName: "Name of Professional",
  range: "Range",
  referralJob: "Referral Job",
  regularJob: "Auxiliary/Dentist Job",
  solveDisputeButton: "Solve Dispute",
  startDate: "Start Date",
  startTime: "Start Time",
  tableFieldJobDate: "Job Date",
  tableFieldJobId: "Job Id",
  tableFieldJobRole: "Job Role",
  tableFieldOfficeName: "Office Name",
  tableFieldProfessionalName: "Professional Name",
  tableFieldStatus: "Status",
  timesheetDetails: "Timesheet Details",
  timesheetTitle: "Timesheet",
  toastMessageDisputeSolved: "Timesheet Dispute Solved Successfully",
  totalBillableRate: "Total Billable",
  totalPayRate: "Total Pay Rate",
  totalHours: "Total Hours",
  type: "Service Type",
  weekly: "(Weekly)",
  weekNext: "Next",
  weekPrevious: "Previous",
  firstIn: "First in",
  firstOut: "First out",
  otherExpenses: "Other expenses",
  addEditShiftTime: "Add / Edit Time",
  workingHours: "Working Hours",
  setTime: "SET TIME",
  endTimeGreaterThanStartTime: "End time must be later than start time.",
  breakTimeInBwShiftTime:
    "Break/Lunch time should be in between submitted time",
  breakTimeOverlapMsg:
    "The break/Lunch times for the two breaks should not overlap.",
  addEdit: "Add / Edit",
  billRatePlusTotalExpense:
    "Bill Amount (Expense is not included) + Total expenses",
  billAmountInfo:
    "(hours * bill rate excluding add on charges)+ placement support fee + dds service fee + hourly escalation",
  addedBreakTime: "Added Break/Lunch Time ({count} of 2)",
  status: "Status",
  statusList: {
    approved: "Approved",
    cancelled: "Cancelled",
    disputeRaised: "Dispute Raised",
    pending: "Pending",
    rejected: "Rejected",
    submitted: "Submitted",
  },
  submittedDate: "Submitted Date",
};
